import { Component } from "@angular/core";
import { Router } from "@angular/router";
//import { TranslateService } from "@ngx-translate/core";
import { AuthService } from "../service/auth/auth.service";

import { UserService } from "../service/user/user.service";


@Component({
  selector: "app-sign-up",
  templateUrl: "./sign-up.component.html",
  styleUrls: ["./sign-up.component.css"],
})
export class SignUpComponent {
  accountOptions: any[] = [];

  accountType: string = "personal";
  showPassword = false;
  showConfirmPassword = false;
  email: string = "";
  password: string = "";
  confirmPassword: string = "";
  phoneNumber: string = "";
  name: string = "";

  constructor(
    private authService: AuthService,
    private userService: UserService,
    private router: Router,
    //private translate: TranslateService
  ) { }
  ngOnInit() {
    //this.getTranslate();

    // this.translate.onLangChange.subscribe((translations) => {
    //   console.log(translations);
    //   this.getTranslate();
    // });
  }
  getTranslate() {
    // this.translate
    //   .get(["personal_account", "company_account"])
    //   .subscribe((translations) => {
    //     this.accountOptions = [
    //       { label: translations["personal_account"], value: "personal" },
    //       { label: translations["company_account"], value: "company" },
    //     ];
    //   });
  }
  toggleShowPassword() {
    this.showPassword = !this.showPassword;
  }

  toggleConfirmShowPassword() {
    this.showConfirmPassword = !this.showConfirmPassword;
  }

  signUp() {
    if (this.password !== this.confirmPassword) {
      alert("Password and Confirm Password must be the same");
      return;
    }

    const user = {
      email: this.email,
      sub: this.password,
      phone: this.phoneNumber,
      name: this.name,
    };

    this.authService.registerUser(user).subscribe((response: any) => {
      this.userService.setTokenInfo(
        response.accessToken,
        response.refreshToken,
        response.userId,
        response.role
      );
      this.userService.setUserInfo(user);
      window.location.href = "/";
    });
  }


}
